import http from '@/uteis/http'
import { criarInativacao } from '@/uteis/action/estrutura/inativar'

export default class EstruturaService {
  async buscarDepartamentoInativa (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/migracao/departamento', { params: filtro }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/migracao/departamento', { params: filtro }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async getEstruturasInativas (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/participantes/estrutura/inativas', { params: filtro }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/participantes/estrutura/inativas', { params: filtro }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async inativarEstrutura (data, dadosSessao) {
    const inativar = criarInativacao(data, dadosSessao)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/participantes/estrutura/inativas', inativar).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/participantes/estrutura/inativas', inativar).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async excluirEstruturaInativa (identificador) {
    var url = `/d0593/pae-back/v1/participantes/estrutura/inativas/${identificador}`
    return new Promise((resolve, reject) => {
      http.delete(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.delete(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
